<template>
    <div class="about-popup">
        <div class="about-close-box" @click="clickClose"><div class="about-close"></div></div>
        <div class="about-popup-content" :style="'height:'+height+'px'">
            <div class="about-title"></div>
            <div class="about-content">
                <img class="about-pic" :src="picImg1" alt="">
                <div class="about-paragragh">
                    <p>连云港桃花涧景区，自然风光优美，远古文化深厚，宗教文化源远流长。</p>
                    <p>桃花涧景区是国家级风景名胜区云台山风景名胜区的一个重要组成部分，位于连云港市古城海州锦屏山南麓，距连云港市区仅5公里。整个景区占地面积4.5平方公里，依山傍水，分东西两个部分：东部是景色清幽的桃花涧，共有岩画、石刻、奇石、幽涧、龙潭、岩洞、古寺构成的桃花涧“三十六”景，集自然风景和人文景观于一体。西部为将军崖岩画，桃花涧旧石器遗址和石刻文化艺术园。是国内著名的以观赏原始岩画、石刻艺术和自然风景特色的山间园林和旅游胜地。</p>
                    <p>连云港桃花涧，2003年被国家旅游局评定“AAAA”级风景区，同年被市政府授予“文明风景区”。</p>
                    <p><span class="bold">官网地址：</span><span class="link" @click="clickGoToLink">http://www.thjchina.com/</span></p>
                    <p><img class="about-pic" :src="picImg2" alt=""></p>
                </div>
                <div class="about-paragragh">
                    <p><i class="iconfont icon-gps"></i><span class="bold">景区地址：</span></p>
                    <p><img class="about-pic" src="http://api.map.baidu.com/staticimage/v2?ak=42d2ca1a5a81752606c9e405297d1d23&mcode=666666&center=119.154071,34.554142&width=400&height=300&zoom=11" alt=""></p>
                    <div>乘车路线：3路，4路，5路公交车</div>
                </div>
                <div class="report-code-img-outbox about-outbox">
                    <div class="dsp-flex">
                        <div class="report-code-img-box">
                            <img :src="codeImg1" class="report-code-img" alt="">
                            <div class="report-code-text">扫码关注公众号</div>
                        </div>
                        <div class="report-code-img-box">
                            <img :src="codeImg2" class="report-code-img" alt="">
                            <div class="report-code-text">抖音号</div>
                        </div>
                    </div>
                    <!-- <div class="report-note">*活动最终解释权由连云港桃花涧景区所有</div> -->
                </div>
            </div>
        </div>
        <!-- <div class="about-popup-button">
            <button class="about-button">马上邀请</button>
        </div>
        <div class="about-flower flower1"></div>
        <div class="about-flower flower2"></div> -->
    </div>
</template>

<script>
import { DOM } from '../modules/utils';
export default {
    name: 'AboutPopup',
    computed: {

    },
    data() {
        return {
            height: 600,
            picImg1: 'http://m1.2048.net/duoniu/images_thj/about/about-pic1.png',
            picImg2: 'http://m1.2048.net/duoniu/images_thj/about/about-pic2.png',
            codeImg1: 'http://m1.2048.net/duoniu/images_thj/report/code1.png',
            codeImg2: 'http://m1.2048.net/duoniu/images_thj/report/code2.png'
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.height = innerHeight*0.75;
        }, 20);
    },
    methods: {
        clickClose() {
            // DOM.resetStopTouchById('reportPage');
            this.$store.state.user.reportShowAbout = false;
        },
        clickGoToLink() {
            // DOM.resetStopTouchById('reportPage');
            window.location.replace('http://www.thjchina.com/');
        }
    }
}
</script>